<template>
  <div class="p-4 flex items-center justify-center min-h-screen bg-light-bg dark:bg-dark-bg">

    <div class="bg-white p-8 rounded-lg shadow-lg w-full sm:w-96 dark:bg-dark-box-bg dark:border dark:border-dark-border">
      <div class="text-center mb-6">
        <h1 class="text-2xl font-semibold text-gray-700 dark:text-dark-text">Rejestracja</h1>
      </div>

      <form @submit.prevent="submitForm" class="space-y-6">
        <div class="space-y-2">
          <label for="firstName" class="block text-sm font-medium text-gray-700 dark:text-dark-text">Imię:</label>
          <input type="text" id="firstName" v-model="form.firstName" class="block w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text" required />
        </div>

        <div class="space-y-2">
          <label for="lastName" class="block text-sm font-medium text-gray-700 dark:text-dark-text">Nazwisko:</label>
          <input type="text" id="lastName" v-model="form.lastName" class="block w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text" required />
        </div>

        <div class="space-y-2">
          <label for="phone" class="block text-sm font-medium text-gray-700 dark:text-dark-text">Telefon:</label>
          <input type="text" id="phone" v-model="form.phone" class="block w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text" required />
        </div>

        <div class="space-y-2">
          <label for="password" class="block text-sm font-medium text-gray-700 dark:text-dark-text">Hasło:</label>
          <input type="password" id="password" v-model="form.password" class="block w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text" required />
        </div>

        <div class="space-y-2">
          <label for="confirmPassword" class="block text-sm font-medium text-gray-700 dark:text-dark-text">Potwierdź hasło:</label>
          <input type="password" id="confirmPassword" v-model="form.confirmPassword" class="block w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:bg-dark-box-bg dark:border-dark-border dark:text-dark-text" required />
        </div>

        <div class="flex justify-center">
          <button type="submit" class="w-full py-3 bg-teal-700 text-white font-semibold rounded-md shadow-md hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 dark:bg-teal-600 dark:hover:bg-teal-500">
            Zarejestruj się
          </button>
        </div>

        <p v-if="errorMessage" class="text-red-600 text-sm mt-4">{{ errorMessage }}</p>
        <p v-if="successMessage" class="text-green-600 text-sm mt-4">{{ successMessage }}</p>
      </form>
    </div>
  </div>
</template>

<script>
import authService from '@/services/authService';
export default {
  name: 'RegisterPage',
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
        // email: '',
        phone: '',
        password: '',
        confirmPassword: ''
      },
      errorMessage: '',
      successMessage: ''
    };
  },
  methods: {
    async submitForm() {
      if (this.form.password !== this.form.confirmPassword) {
        this.errorMessage = "Hasła się nie zgadzają!";
        this.successMessage = '';
        return;
      }
      try {
        await authService.register(this.form);
        this.successMessage = 'Użytkownik zarejestrowany pomyślnie!';
        this.errorMessage = '';
        this.$router.push('/login');
      } catch (error) {
        this.errorMessage = error.response?.data?.message || 'Rejestracja nieudana!';
        this.successMessage = '';
      }
    }
  }
};
</script>